//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../axios/axios.js'
import RequestAutoAssignBrigades from './RequestAutoAssignBrigades.vue'

export default {
  name: 'RequestAutoAssignItem',
  props: {
    request: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      hasExcludedActually: false
    }
  },
  created: function () {
    this.loadBrigades()
  },
  methods: {
    onShowAutoAssignBrigades: function () {
      this.$d.dialog(this).show({
        maximized: false,
        class: 'request-auto-assign-brigades-dialog',
        headerLabel: 'Бригады для автоматического назначения',
        contentComponent: RequestAutoAssignBrigades,
        contentProps: {
          requestId: this.request.requestId
        }
      })
    },
    loadBrigades: function () {
      axiosGet({
        url: '/service/delta/request/getAutoAssignBrigades?id=' + this.request.requestId,
        onSuccess: response => {
          const brigades = response.data.result
          if (brigades && brigades.length) {
            this.hasExcludedActually = !!brigades.find(brigade => !!brigade.excludedActually)
          }
        },
        onFailure: 'Ошибка получения бригад для автоназначения'
      })
    }
  }
}
